"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Data is an array of events which have come from the real-time api
// The current requirement for how data is stored in the v2 player is an absolute dogs breakfast.
// The whole thing really needs to be fixed. This parser is not fully implemented as yet, but
// to get an idea for the complexities of the store set up look at the v2-callback parser.
// My apologies if you need to work on this, but it was broken when I got here...
var parse = function parse(data) {
  return {
    activeTopic: 0,
    topics: [{
      name: 'ALL TOPICS',
      type: 'category',
      keywords: data.filter(function (e) {
        return e.type === 'KnowledgeEvent' && e.extractedKeywords;
      }).map(function (e) {
        return e.extractedKeywords;
      }).reduce(function (acc, e) {
        return acc.concat(e);
      }, [])
    }].concat(data.filter(function (e) {
      return e.type === 'KnowledgeEvent' && e.extractedTopics;
    }).map(function (e) {
      return e.extractedTopics;
    }).reduce(function (acc, e) {
      return acc.concat(e);
    }, []).reduce(function (acc, t) {
      return acc.set(t.name, t);
    }, new Map()).values()),
    activeGroup: 0,
    groups: [].concat(data.filter(function (e) {
      return e.type === 'KnowledgeEvent' && e.spottedPhraseGroups;
    }).map(function (e) {
      return e.spottedPhraseGroups;
    }).reduce(function (acc, e) {
      return acc.concat(e);
    }, []).reduce(function (acc, t) {
      return acc.set(t.name, t);
    }, new Map()).values()),
    activeSpeaker: 0,
    speakers: [],
    transcriptSpeakers: [],
    transcript: [].concat(data.filter(function (e) {
      return e.type === 'TranscriptEvent';
    }).map(function (e) {
      return e.words;
    }).reduce(function (acc, e) {
      return acc.concat(e);
    }, []).map(function (w) {
      return w.w === '</s>' ? _extends({}, w, {
        w: '...'
      }) : w;
    }).reduce(function (acc, w) {
      return acc.set(w.p, w);
    }, new Map()).values()) // TODO: Add classifiers if required later.

  };
};

var _default = parse;
exports["default"] = _default;